import './_RemoveTokenButton-d7f5985b.css';

var classes = {"TokenButton":"prc-Token-TokenButton-F4Y8h"};

export { classes as default };
